export default "__VITE_ASSET__Cn3y4c9w__"